import { createFeatureSelector } from '@ngrx/store';
import { ClinicalState } from 'src/app/clinical/store/clinical.state';

export const clinicalFeatureKey = 'clinical';

export const selectFeature = createFeatureSelector<ClinicalState>(clinicalFeatureKey);
